<template>
  <div>
    <div>
        <div>
            <!--<a href="https://www.12371.cn/bxgd/" title="" target="_blank">
                <img src="/static/images/baxiangguiding.jpg" style="width: 100%;height:150px;display: block"/>
            </a>-->
            <a href="https://www.ahxf.gov.cn/zt/20jsizqh/Index" title="" target="_blank">
                <img src="/static/images/20jsizqh.jpg" style="width: 100%;display: block"/>
            </a>
        </div>

        <HeaderIndex></HeaderIndex>

        <div class="w1100" style="display:none;">
            <!--<a href="http://www.ahxf.gov.cn/Zt/20da/Index" title="" target="_blank">
            <img src="/static/images/12.jpg" />
            </a>-->
            <a href="https://www.ahxf.gov.cn/Zt/shzysx/Index" title="" target="_blank">
            <img src="/static/images/sixiang.png" style="width: 100%;"/>
            </a>
        </div>
        <div class="w1100">
        <div class="floatL marginT20">
            <div class="block" style="width:414px;position: relative;"> 
                <el-carousel height="290px">
                <el-carousel-item v-for="(item,index) in imageData" :key="'image-index-'+index">
                    <a :href="'/qsxf-web/detail?id='+item.contentId" target="_blank">
                        <img :src="showImage(item.image)" border="0" style="width:100%;height:100%;">
                        <div style="font: 18px/32px '微软雅黑','黑体';width:100%;position: absolute;left:0px;bottom:37px;text-align:center;color:#ffffff;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;overflow: hidden;">{{item.title}}</div>
                    </a>
                </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="floatR marginT20" style="width:662px;">
        <div class="LongDistanceEducation_tit">
            <ul>
                <li id="xx1" class="td1" onmouseover="OMO2(1,2,'xx')" onclick="javascript:window.open('/qsxf-web/module/list?code=6145')">时政资讯</li>
                <li id="xx2" class="td2" onmouseover="OMO2(2,2,'xx')" onclick="javascript:window.open('/qsxf-web/module/list?code=6146')">潜阳要闻</li>
                <div class="clear"></div>
            </ul>
        </div>
        <div id="xxList1" class="">
            <div class="LongDistance_List f14">
                <!-- <div class="hot_tit" v-if="this.sszzData.head.image">
                    <a :href="'/qsxf-web/detail?id='+this.sszzData.head.contentId" :title="this.sszzData.head.title" target="_blank">
                        <img :src="showImage(this.sszzData.head.image)" border="0" style="height:50px;">
                    </a>
                </div> -->
                <div class="introduction">
                    <a :href="'/qsxf-web/detail?id='+this.sszzData.head.contentId" :title="this.sszzData.head.title" target="_blank">
                        <template v-if="sszzData.head.summary.length > 70">
                        {{sszzData.head.summary.substring(0,70)}}...
                        </template>
                        <template v-else-if="sszzData.head.summary.length > 0">
                        {{sszzData.head.summary}}
                        </template>
                        <template v-else>
                        {{sszzData.head.title}}
                        </template>
                        <span style="color:#f00;">[详细]</span>
                    </a>
                </div>
                <ul class="Information f14">
                    <template v-for="(itemData,i) in this.sszzData.body">
                        <li :key="'sszzData-index-'+i">
                            <div class="floatL w528 ellipsis">
                                <a :href="'/qsxf-web/detail?id='+itemData.contentId" :title="itemData.title" target="_blank">{{itemData.title}}</a>
                            </div>
                            <div class="floatR date">[{{itemData.createTime.substring(5,10)}}]</div>
                        </li>
                    </template>
                </ul>
            </div> 
        </div>
        <div id="xxList2" class="hidden">
            <div class="LongDistance_List f14">
                <!-- <div class="hot_tit" v-if="this.qyywData.head.image">
                    <a :href="'/qsxf-web/detail?id='+this.qyywData.head.contentId" :title="this.qyywData.head.title" target="_blank">
                        <img :src="showImage(this.qyywData.head.image)" border="0" style="height:50px;">
                    </a>
                </div> -->
                <div class="introduction">
                    <a :href="'/qsxf-web/detail?id='+this.qyywData.head.contentId" :title="this.qyywData.head.title" target="_blank">
                        <template v-if="qyywData.head.summary.length > 70">
                        {{qyywData.head.summary.substring(0,70)}}...
                        </template>
                        <template v-else-if="qyywData.head.summary">
                        {{qyywData.head.summary}}
                        </template>
                        <template v-else>
                        {{qyywData.head.title}}
                        </template>
                        <span style="color:#f00;">[详细]</span>
                    </a>
                </div>
                <ul class="Information f14">
                    <template v-for="(itemData,i) in this.qyywData.body">
                        <li :key="'qyywData-index-'+i">
                            <div class="floatL w528 ellipsis">
                                <a :href="'/qsxf-web/detail?id='+itemData.contentId" :title="itemData.title" target="_blank">{{itemData.title}}</a>
                            </div>
                            <div class="floatR date">[{{itemData.createTime.substring(5,10)}}]</div>
                        </li>
                    </template>
                </ul>
            </div> 
        </div>
        </div>
        <div class="clear"></div>
    </div>


    <div class="w1100" style="margin-top:10px;">
        <!--<a style="margin-right:5px;" href="https://www.12371.cn/djxx/" title="" target="_blank" class="floatL"><img src="/static/images/jiaoyu.png" width="270" height="80"></a>-->
        <!--<a style="margin-right:5px;" href="http://www.12371.cn/special/xxzd/" title="" target="_blank" class="floatL"><img src="/static/images/pic1new.jpg" width="270" height="80"></a>-->		
        <!--<a style="margin-right:5px;" href="/qsxf-web/module/index?code=6722" title="" target="_blank" class="floatL"><img src="/static/images/Banner_21.jpg" width="270" height="80"></a>-->
        <!--<a style="margin-right:5px;" href="http://xuexi.12371.cn/pxsfb/index.shtml" title="" target="_blank" class="floatL"><img src="/static/images/logo2.jpg" width="270" height="80"></a> -->
        <!--<a style="margin-right:5px;" href="/qsxf-web/module/index?code=6755" title="" target="_blank" class="floatL"><img src="/static/images/shce01.jpg" width="270" height="80"></a> -->      
        <!--<a style="margin-right:5px;" href="https://www.ahxf.gov.cn/Zt/shzysx/List?Id=6797" title="" target="_blank" class="floatL"><img src="/static/images/xfbook.png" width="270" height="80"></a>   -->   
        <!--<a style="margin-right:5px;" href="https://www.12371.cn/special/sbby/" title="" target="_blank" class="floatL"><img src="/static/images/bangyang.jpg" width="270" height="80"></a>     -->
        <!--学习贯彻党的二十届三中全会精神 、全国党员教育示范培训班、学习身边榜样、安徽党员大课堂-->
        <!--<a style="margin-right:5px;" href="https://www.ahxf.gov.cn/zt/20jszqh/Index" title="" target="_blank" class="floatL"><img src="/static/images/szqh.png" width="270" height="80"></a>-->
        <!-- <a style="margin-right:5px;" href="http://xuexi.12371.cn/pxsfb/index.shtml" title="" target="_blank" class="floatL"><img src="/static/images/logo2.jpg" width="270" height="80"></a> -->
        <a style="margin-right:5px;" href="https://www.ahxf.gov.cn/zt/Video2025/Index" title="" target="_blank" class="floatL"><img src="/static/images/11152849344.jpg" width="270" height="80"></a>
        <!--<a style="margin-right:5px;" href="https://www.12371.cn/special/zglz5/" title="" target="_blank" class="floatL"><img src="/static/images/zglz.jpg" width="270" height="80"></a>-->
        <a style="margin-right:5px;" href="https://www.12371.cn/special/djsx/" title="" target="_blank" class="floatL"><img src="/static/images/ahsx.jpg" width="270" height="80"></a>
        <a style="margin-right:5px;" href="https://www.12371.cn/special/sbby/" title="" target="_blank" class="floatL"><img src="/static/images/bangyang.jpg" width="270" height="80"></a>
        <a style="margin-right:5px;" href="https://www.ahxf.gov.cn/Zt/classroom/index" title="" target="_blank" class="floatL"><img src="/static/images/ahdydkt.jpg" width="270" height="80"></a>
        
        <div class="clear"></div>
    </div>

    <div class="w1100">
        <div class="floatL w350 marginT10">  
            <div class="floatL notice_tit_old">通知公告</div>
            <div class="floatR f14 fb notice_tit_more"><a href="/qsxf-web/module/list?code=6178" title="" target="_blank">更多&gt;&gt;</a></div>
            <div class="clear"></div>
            <div class="notice_List f14">
                <div id="wzscorll" style="overflow:hidden;height:150px;">
                    <ul>
                        <li v-for="(item ,i) in this.noticeData.notice" :key="'notice'+i">
                            <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">{{item.title}}</a>
                        </li>
                    </ul>
                </div>
            </div>                        
        </div>
        <div class="floatL w350 marginL25 marginT10">
            <div class="floatL notice_tit_old">人事任免</div>
            <div class="floatR f14 fb notice_tit_more"><a href="/qsxf-web/module/list?code=6177" title="" target="_blank">更多&gt;&gt;</a></div>
            <div class="clear"></div>
            <div class="notice_List f14">
                <ul>
                    <li v-for="(item ,i) in this.noticeData.rsrm" :key="'rsrm'+i">
                        <!--
                        <a @click="publishEndTime()" v-if="item.isPublishEnd" :title="item.title">{{item.title}}</a>
                        -->
                        <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">{{item.title}}</a>
                    </li>   
                </ul>
            </div>                         
        </div>
    	<div class="floatR w350 marginT10">
            <div class="floatL notice_tit_old">党务指南</div>
            <div class="floatR f14 fb notice_tit_more"><a href="/qsxf-web/module/index?code=6253" title="" target="_blank">更多&gt;&gt;</a></div>
            <div class="clear"></div>
            <div class="notice_List f14">
                <ul>
                    <li v-for="(item ,i) in this.noticeData.dwzn" :key="'dwzn'+i">
                       <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">{{item.title}}</a>
                    </li>  
                </ul>
            </div>  
        </div>
        <div class="clear"></div>
    </div>
    
    <div class="RollingPictures marginT10 border_a border_ECEAEB f14">
        <div id="demo">
            <table align="center" cellpadding="0" cellspace="0" border="0">
                <tbody><tr>
                    <td id="demo1" valign="top">
                        <table width="1190" border="0" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <td>
                                        <ul>
                                            <li v-for="(item,index) in imageList" :key="'image-index1-'+index">
                                                <div class="border_a border_ECEAEB">
                                                    <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank"><img :src="showImage(item.image)" width="145" height="106"></a>
                                                </div>
                                                <div class="ellipsis RollingPicturesFonts">
                                                    <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">{{item.title}}</a>
                                                </div>
                                            </li>               
                                        </ul>
                                    </td>
                                </tr>
                            </tbody></table>
                        </td>
                        <td id="demo2" valign="top">
                            <table width="1190" border="0" cellspacing="0" cellpadding="0">
                                <tbody><tr>
                                    <td>
                                        <ul>
                                            <li v-for="(item,index) in imageList" :key="'image-index2-'+index">
                                                <div class="border_a border_ECEAEB">
                                                    <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank"><img :src="showImage(item.image)" width="145" height="106"></a>
                                                </div>
                                                <div class="ellipsis RollingPicturesFonts">
                                                    <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">{{item.title}}</a>
                                                </div>
                                            </li>                         
                                        </ul>
                                    </td>
                                </tr>
                            </tbody></table>
                        </td>
                    </tr>
                </tbody>
            </table>  
        </div>
    </div>  

    
    <div class="w1100">
        <img src="/static/images/1.gif">
    </div>

    <div class="w1100">
	<div style="float:left">
        <template v-for="(itemList,index) in this.cultureData">
            <div :class="(index+1)%2 == 0 ? 'floatL w393 marginL25' : 'floatL w393'" :key="'moduleMain'+itemList.code">
                <div class="floatL LongDistanceEducation_tit_old">{{itemList.name}}</div>
                <div class="floatR fb gbzc_tit_more"><a :href="'/qsxf-web/module/index?code='+itemList.code" title="" target="_blank">更多&gt;&gt;</a></div>
                <div class="clear"></div>
                <div class="syss_little marginT10">
                    <ul class="f14">
                        <li :id="itemList.key+'1'" class="td2" @mouseover="onModuleData(1,itemList.list.length+1,itemList.key)" style="width:0"></li>
                        <li :id="itemList.key+''+(i+2)" v-for="(item,i) in itemList.list" :key="'moduleItem'+item.code" class="td2" @mouseover="onModuleData(i+2,itemList.list.length+1,itemList.key)" @click="openModule(item.code,'list')">{{item.name}}</li>
                        <!--党建园地-->
                        <!--<li v-if="itemList.code==6151" id="djyd6" @click="openModule('6154')" onmouseover="OMO2(6,6,'djyd')">电教远教</li>-->
                        <!--<li v-if="itemList.code==6149" @click="openModule('6150','index')">人才专区</li>-->
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="syss_List f14">
                    <template v-for="(item,i) in itemList.list">
                    <ul :id="itemList.key+'List1'" :key="i+'-moduleItemDetail'+item.code" v-if="i == 0">
                        <li v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" :title="itemData.title" target="_blank">
                            {{itemData.title}}
                            </a>
                        </li>
                    </ul>
                    </template>
                    <ul :id="itemList.key+'List'+(i+2)" class="hidden" v-for="(item,i) in itemList.list" :key="'moduleItem1'+item.code">
                        <li v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" :title="itemData.title" target="_blank">
                            {{itemData.title}}
                            </a>
                        </li>
                    </ul>
                </div>                   
            </div>
            <!--页面布局清除浮动-->
            <div class="clear" v-if="(index+1)%2 == 0" :key="'moduleMainIndex'+itemList.code"></div>
        </template>
        </div>
    <div class="floatR w264">
        <div class="f16 zt_tit" style="background:none;margin-top:-25px"></div>
        <ul class="ztList">
            <li><a href="/qsxf-web/module/index?code=6159" title="" target="_blank"><img src="/static/images/zt_pic1.png" width="261" height="52"></a></li>
            <!--
            <li><a href="/qsxf-web/module/index?code=6164" title="" target="_blank"><img src="/static/images/zt_pic2.png" width="261" height="52"></a></li>
            -->
            <li><a href="/qsxf-web/module/index?code=6232" title="" target="_blank"><img src="/static/images/zt_pic3.jpg" width="261" height="52"></a></li>
            <li><a href="/static/bzxx/index.html" title="" target="_blank"><img src="/static/images/zt_pic4.png" width="261" height="52"></a></li>
            <li>
                <!--http://www.12380.gov.cn/-->
                <a href="/qsxf-web/report" title="" target="_blank">
                    <img src="/static/images/zt_pic5.png" width="261" height="52">
                </a>
            </li>
            <li>
                <a href="/qsxf-web/reportQuestion" title="" target="_blank">
                    <img src="/static/images/zt_pic8.png" width="261" height="52">
                </a>
            </li>
            <!--
            <li><a href="mailto:qsxfw@sina.com" title="" target="_blank"><img src="/static/images/zt_pic6.jpg" width="261" height="52"></a></li>
            -->
            <!--<li><a href="http://www.ahxf.gov.cn/wcwy/" title="" target="_blank"><img src="/static/images/ztbd_pic5.jpg" width="259" height="52"></a></li>-->
            <li><a href="https://www.ahgbjy.gov.cn/resources/sepcialPC/syxxzlall/index.html" title="" target="_blank"><img src="/static/images/ztbd_pic7.jpg" width="259" height="52"></a></li>
        </ul>
        <!--
        <div class="f16 zt_tit">
        <a href="/qsxf-web/module/list?code=6205" title="视频点播" target="_blank">视频点播</a>
        </div>
        <template v-for="item in this.bannerData">
            <template v-if="item.name == '视频点播'">
                <div class="sp_pic" :key="'djlm'+item.code">
                    <template v-for="(itemData,i) in item.list">
                        <div v-if="i == 0" :key="'djlm-'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" :title="itemData.title" target="_blank">
                                <img v-if="itemData.image" :src="showImage(itemData.image)" width="264" height="180">
                                <video v-else-if="itemData.flv" :src="itemData.flv" width="264" height="180"></video>
                            </a>
                        </div>
                    </template>
                </div>
            </template>
        </template>
        -->
        </div>
    </div>

    <div class="clear"></div>

    <div class="w1100">
        <!--
        <img src="/static/images/5.gif">
        -->
        <a href="http://dygbjy.12371.cn/" target="_blank">
            <img style="width: 1100px;margin-top: 5px;" src="/static/images/dygbjy.jpg">
        </a>
    </div>

    <!--教育课件-->
    <div class="w1100" v-if="this.kczxData.length > 0" style="display: none;">
        <div>
            <div class="w393'">
                <div class="floatL LongDistanceEducation_tit_old">教育课件</div>
                <div class="floatR fb gbzc_tit_more" style="width: calc(100% - 72px);"><a href="/qsxf-web/module/index?code=7100" title="" target="_blank">更多&gt;&gt;</a></div>
                <div class="clear"></div>
                <div class="syss_little marginT10" style="width:100%;padding-left: 0px;">
                    <ul class="f14">
                        <li id="kczx1" class="td2" @mouseover="onModuleData(1,kczxData.length+1,'kczx')" style="width:0"></li>
                        <li style="width: 100px;" :id="'kczx'+(i+2)" v-for="(item,i) in kczxData" :key="'kczxData'+i" class="td2" @mouseover="onModuleData(i+2,kczxData.length+1,'kczx')" @click="openModule(item.channelId,'list')">
						{{item.channelName}}
						</li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="syss_List f14">
                    <template v-for="(item,i) in kczxData">
                    <ul id="kczxList1" :key="i+'-moduleItemDetail'+item.channelId" v-if="i == 0">
                        <li class="new_module_img" v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" class="" target="_blank">
                                <div class="img_container">
                                    <img style="height: 100%;width: 100%;" v-if="itemData.image" :src="itemData.image" />
                                </div>
                                <div class="kczx">
                                    <div class="list kczx_a">
                                        <span>{{itemData.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    </template>
                    <ul :id="'kczxList'+(i+2)" class="hidden" v-for="(item,i) in kczxData" :key="'moduleItem1'+item.channelId">
                        <li class="new_module_img" v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" class="" target="_blank">
                                <div class="img_container">
                                    <img style="height: 100%;width: 100%;" v-if="itemData.image" :src="itemData.image" />
                                </div>
                                <div class="kczx">
                                    <div class="list kczx_a">
                                        <span>{{itemData.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>                   
            </div>
            <!--页面布局清除浮动-->
            <div class="clear"></div>
        </div>
    </div>


    <!--党建栏目-->
    <div class="w1100" v-if="this.djlmData.length > 0" style="display:none;">
        <div>
            <div class="w393'">
                <div class="floatL LongDistanceEducation_tit_old">党建栏目</div>
                <div class="floatR fb gbzc_tit_more" style="width: calc(100% - 72px);"><a href="/qsxf-web/module/index?code=7200" title="" target="_blank">更多&gt;&gt;</a></div>
                <div class="clear"></div>
                <div class="syss_little marginT10" style="width:100%;padding-left: 0px;">
                    <ul class="f14">
                        <li id="djlm1" class="td2" @mouseover="onModuleData(1,djlmData.length+1,'djlm')" style="width:0"></li>
                        <li style="width: 100px;" :id="'djlm'+(i+2)" v-for="(item,i) in djlmData" :key="'djlmData'+i" class="td2" @mouseover="onModuleData(i+2,djlmData.length+1,'djlm')" @click="openModule(item.channelId,'list')">
						{{item.channelName}}
						</li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="syss_List f14">
                    <template v-for="(item,i) in djlmData">
                    <ul id="djlmList1" :key="i+'-moduleItemDetail'+item.channelId" v-if="i == 0">
                        <li class="new_module_img" v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" class="" target="_blank">
                                <div class="img_container">
                                    <img style="height: 100%;width: 100%;" v-if="itemData.image" :src="itemData.image" />
                                </div>
                                <div class="kczx">
                                    <div class="list kczx_a">
                                        <span>{{itemData.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    </template>
                    <ul :id="'djlmList'+(i+2)" class="hidden" v-for="(item,i) in djlmData" :key="'moduleItem1'+item.channelId">
                        <li class="new_module_img" v-for="itemData in item.data" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" class="" target="_blank">
                                <div class="img_container">
                                    <img style="height: 100%;width: 100%;" v-if="itemData.image" :src="itemData.image" />
                                </div>
                                <div class="kczx">
                                    <div class="list kczx_a">
                                        <span>{{itemData.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>                   
            </div>
            <!--页面布局清除浮动-->
            <div class="clear"></div>
        </div>
    </div>

    <!--先锋影视-->
    <div class="w1100" v-if="this.xfysData.length > 0">
        <div>
            <div class="w393'">
                <div class="floatL LongDistanceEducation_tit_old">先锋影视</div>
                <div class="floatR fb gbzc_tit_more" style="width: calc(100% - 72px);"><a href="/qsxf-web/module/list?code=7300" title="" target="_blank">更多&gt;&gt;</a></div>
                <div class="clear"></div>
                <div class="syss_List f14">
                    <ul>
                        <li class="new_video_img" v-for="itemData in xfysData" :key="'moduleContent'+itemData.contentId">
                            <a :href="'/qsxf-web/detail?id='+itemData.contentId" class="" target="_blank">
                                <div class="video_container">
                                    <img style="height: 100%;width: 100%;" v-if="itemData.image" :src="itemData.image" />
                                </div>
                                <div class="kczx">
                                    <div class="list kczx_a" style="text-align: center;">
                                        <span>{{itemData.title}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>                   
            </div>
            <!--页面布局清除浮动-->
            <div class="clear"></div>
        </div>
    </div>

    <!--乡镇栏目，2021-08-02屏蔽-->
    <div class="w1100" v-if="this.kczxData.length == 0" style="display: none;">
    	<div class="floatL" style="width:811px; margin-top:10px;">
            <template v-for="(item ,i) in this.areaData">
                <div :class="(i+3)%3 == 0 ? 'floatL w257' : 'floatL w257 marginL20'" :key="'area'+i" v-if="item.code != 6230 && item.code != 6231">
                    <div class="floatL LongDistanceEducation_tit_old">{{item.name}}</div>
                    <div class="floatR f14 fb LongDistanceEducation_more">
                        <a :href="'/qsxf-web/module/list?code='+item.code" :title="item.name" target="_blank">&gt;&gt;更多</a>
                    </div>
                    <div class="clear"></div>
                    <div class="LongDistanceEducation_List f14">
                        <ul>
                            <li v-for="(itemList ,j) in item.list" :key="'area-list'+j">
                                <a :href="'/qsxf-web/detail?id='+itemList.contentId" :title="itemList.title" target="_blank">{{itemList.title}}</a>
                            </li> 
                        </ul>
                    </div>                      
                </div>
            </template>
            <template>
                <div class="floatL w257 marginL20">
                    <div class="floatL fjkf w257">
                        <ul>
                            <li id="fj1" class="td2" onmouseover="OMO2(1,3,'fj')" style="width:0px;"></li>
                            <li id="fj2" class="td2" onmouseover="OMO2(2,3,'fj')" onclick="javascript:window.open('/qsxf-web/module/list?code=6230')">风景区</li>
                            <li id="fj3" class="td1" onmouseover="OMO2(3,3,'fj')" onclick="javascript:window.open('/qsxf-web/module/list?code=6231')">经开区</li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                    <div class="clear"></div>
                    <div class="LongDistanceEducation_List f14">
                        <ul id="fjList1" class="">
                            <li v-for="(itemList ,j) in cityData.kfq" :key="'area-list1'+j">
                                <a :href="'/qsxf-web/detail?id='+itemList.contentId" :title="itemList.title" target="_blank">{{itemList.title}}</a>
                            </li> 
                        </ul>
                        <ul id="fjList2" class="hidden">
                            <li v-for="(itemList ,j) in cityData.fjq" :key="'area-lis2'+j">
                                <a :href="'/qsxf-web/detail?id='+itemList.contentId" :title="itemList.title" target="_blank">{{itemList.title}}</a>
                            </li> 
                        </ul>
                        <ul id="fjList3" class="hidden">
                            <li v-for="(itemList ,j) in cityData.kfq" :key="'area-list3'+j">
                                <a :href="'/qsxf-web/detail?id='+itemList.contentId" :title="itemList.title" target="_blank">{{itemList.title}}</a>
                            </li> 
                        </ul>
                    </div>                      
                </div>
            </template>
        </div>
    	<div class="floatR w264">
        	<div class="f16 zt_tit"><a href="/qsxf-web/module/index?code=6253" title="党务指南" target="_blank">党务指南</a></div>
            <div class="dwList">
            	<ul>
                	<li style="margin-right:15px;"><a href="/qsxf-web/module/list?code=6254" title="" target="_blank"><img src="/static/images/dw_pic1.jpg" width="124" height="46"></a></li>
                    <li><a href="/qsxf-web/module/list?code=6255" title="" target="_blank"><img src="/static/images/dw_pic2.jpg" width="124" height="46"></a></li>
                	<li style="margin-right:15px;"><a href="/qsxf-web/module/list?code=6256" title="" target="_blank"><img src="/static/images/dw_pic3.jpg" width="124" height="46"></a></li>
                	<li><a href="/qsxf-web/module/list?code=6257" title="" target="_blank"><img src="/static/images/dw_pic4.jpg" width="124" height="46"></a></li>
                    <div class="clear"></div>
                </ul>
            </div>
            <div class="f16 zt_tit"><a href="/qsxf-web/module/list?code=6252" title="党建刊物" target="_blank">党建刊物</a></div>
            <!--刊物-->
            <div class="blk_1">
                <a class="LeftBotton" onmousedown="ISL_GoDown_1()" onmouseup="ISL_StopDown_1()" onmouseout="ISL_StopDown_1()" href="javascript:void(0);" target="_self"></a>
                <div class="floatL" style="padding:9px;background:#F1E9DE; margin:0 10px;">
                    <div class="pcont" id="ISL_Cont_1">
                    <div class="ycypList">
                        <div id="List1_1">
                            <!-- piclist begin -->
                            <template v-for="item in this.bannerData">
                                <template v-if="item.name == '党建刊物'">
                                <ul class="zzjb_list" :key="'djkw'+item.code">
                                    <li v-for="itemData in item.list" :key="'djkw-'+itemData.contentId">
                                        <a :href="itemData.url" :title="itemData.title" target="_blank">
                                        <img :src="showImage(itemData.image)" width="144" height="178"></a>
                                    </li>
                                </ul> 
                                </template>
                            </template>
                            <!-- piclist end -->
                            <div class="clear"></div>
                        </div>
                        <div id="List1_2">
                            <!-- piclist begin -->
                            <template v-for="item in this.bannerData">
                                <template v-if="item.name == '党建刊物'">
                                <ul class="zzjb_list" :key="'djkw'+item.code">
                                    <li v-for="itemData in item.list" :key="'djkw-'+itemData.contentId">
                                        <a :href="itemData.url" :title="itemData.title" target="_blank">
                                        <img :src="showImage(itemData.image)" width="144" height="178"></a>
                                    </li>
                                </ul> 
                                </template>
                            </template>
                            <!-- piclist end -->
                            <div class="clear"></div>
                        </div>
                        <div class="clear">
                        </div>
                     </div>
                </div>
                </div>
                <a class="RightBotton" onmousedown="ISL_GoUp_1()" onmouseup="ISL_StopUp_1()" onmouseout="ISL_StopUp_1()" href="javascript:void(0);" target="_self"></a>
                <div class="clear"></div>
            </div>
            <!--刊物end-->
            <div class="f16 zt_tit"><a href="/qsxf-web/module/list?code=6251" title="网上看报" target="_blank">网上看报</a></div>
            <div style="border:1px solid #ccc; padding:1px;">
                <div style="width: 260px; height: 216px;">
                    <template v-for="item in this.bannerData">
                        <template v-if="item.name == '网上看报'">
                        <el-carousel height="216px"  :key="item.key+'='+item.code" indicator-position="none">
                            <el-carousel-item v-for="itemData in item.list" :key="'wskb'+itemData.contentId">
                                <a :href="itemData.url" :title="itemData.title" target="_blank">
                                <img style="width: 260px; height: 216px;" :src="showImage(itemData.image)">
                                </a>
                            </el-carousel-item>
                        </el-carousel>
                        </template>
                    </template>
                </div>
            </div>
            <div class="f16 zt_tit">为您服务</div>
            <div class="dwList">
            	<ul>
                	<li style="margin-right:15px"><a href="http://www.weather.com.cn/weather/101220604.shtml" title="" target="_blank"><img src="/static/images/fw_pic1.jpg" width="124" height="46"></a></li>
                	<li><a href="https://www.ctrip.com/" title="" target="_blank"><img src="/static/images/fw_pic2.jpg" width="124" height="46"></a></li>
                    <li style="margin-right:15px"><a href="http://www.csair.com/cn/index.shtml" title="" target="_blank"><img src="/static/images/fw_pic3.jpg" width="124" height="46"></a></li>
                    <li><a href="http://www.12306.cn/mormhweb/" title="" target="_blank"><img src="/static/images/fw_pic4.jpg" width="124" height="46"></a></li>
                    <li style="margin-right:15px"><a href="http://www.haodf.com/" title="" target="_blank"><img src="/static/images/fw_pic5.jpg" width="124" height="46"></a></li>
                    <li><a href="http://stock.eastmoney.com/" title="" target="_blank"><img src="/static/images/fw_pic6.jpg" width="124" height="46"></a></li>
                    <li style="margin-right:15px"><a href="http://www.360doc.com/content/12/0726/10/1542087_226535897.shtml" title="" target="_blank"><img src="/static/images/fw_pic7.jpg" width="124" height="46"></a></li>
                    <li><a href="http://apk.gfan.com/topic_813_1_1.html" title="" target="_blank"><img src="/static/images/fw_pic8.jpg" width="124" height="46"></a></li>
                    <li style="margin-right:15px"><a href="http://www.ip138.com/post/" title="" target="_blank"><img src="/static/images/fw_pic9.jpg" width="124" height="46"></a></li>
                    <li><a href="http://www.hao123.com/bank" title="" target="_blank"><img src="/static/images/fw_pic10.jpg" width="124" height="46"></a></li>
                    <li style="margin-right:15px"><a href="http://www.ip138.com/" title="" target="_blank"><img src="/static/images/fw_pic11.jpg" width="124" height="46"></a></li>
                    <li><a href="http://www.hao123.com/rili" title="" target="_blank"><img src="/static/images/fw_pic12.jpg" width="124" height="46"></a></li>
                    <div class="clear"></div>
                </ul>
            </div>   
        </div>
        <div class="clear"></div>
    </div>

    <div class="w1100">
        <img src="/static/images/4.gif">
    </div>

   <FooterIndex name="footerIndex"></FooterIndex>

      
    </div>
  </div>
</template>


<script>

import  '../assets/css/css.css'
import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import request from '@/common/request'

export default {
  name: 'HomeIndex',
  data () {
    return {
        noticeData : {
            notice:[],
            dwzn:[],
            rsrm:[]
        },
        areaData : [{"code":6213,"name":"梅城","list":[]},{"code":6214,"name":"天柱山","list":[]},{"code":6215,"name":"水吼","list":[]},{"code":6216,"name":"五庙","list":[]},{"code":6217,"name":"油坝","list":[]},{"code":6218,"name":"王河","list":[]},{"code":6219,"name":"黄泥","list":[]},{"code":6220,"name":"黄铺","list":[]},{"code":6221,"name":"痘姆","list":[]},{"code":6222,"name":"余井","list":[]},{"code":6223,"name":"龙潭","list":[]},{"code":6224,"name":"源潭","list":[]},{"code":6225,"name":"槎水","list":[]},{"code":6226,"name":"黄柏","list":[]},{"code":6227,"name":"官庄","list":[]},{"code":6228,"name":"塔畈","list":[]},{"code":6229,"name":"市直","list":[]},{"code":6230,"name":"风景区","list":[]},{"code":6231,"name":"开发区","list":[]}],
        cityData:{"fjq":[],"kfq":[]},
        cultureData:[
            {"code":6151,"key":"djyd","name":"党建园地",list:[]},
            {"code":6149,"key":"gbrc","name":"干部人才",list:[]}
            // {"code":6156,"key":"zsjs","name":"自身建设",list:[]},
            // {"code":6157,"key":"xjdx","name":"先进典型",list:[]}
        ],
        bannerData:[
            {"code":6251,"key":"wskb","name":"网上看报",list:[]},
            {"code":6252,"key":"djkw","name":"党建刊物",list:[]},
            // {"code":6253,"key":"dwzn","name":"党务指南",list:[]},
            {"code":6205,"key":"djlm","name":"视频点播",list:[]},
            {"code":6145,"key":"szzx","name":"时政资讯",list:[]},
            // {"code":6176,"key":"szzx","name":"时政资讯",list:[]},
            {"code":6146,"key":"qyyw","name":"潜阳要闻",list:[]}
        ],
        imageData:[],
        imageList:[],
        qyywData:{
            head:{
                "summary":""
            },
            body:[]
        },
        sszzData:{
            head:{
                "summary":""
            },
            body:[]
        },
        // 课程中心
        kczxData:[
            
        ],
        // 党建栏目
        djlmData:[
            
        ],
        // 先锋影视
        xfysData:[
            
        ]
    }
  },
  components: {
      FooterIndex,HeaderIndex
  },
  watch: {
    $route(to, from){
        this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
      publishEndTime(){
        this.$notify({
          title: '提示',
          message: '人事任免公示已结束，无法查看',
          type: 'warning'
        });
      },
      openModule:function(code,type){
          if(type == "index"){
            window.open('/qsxf-web/module/index?code='+code);
          }else{
            window.open('/qsxf-web/module/list?code='+code);
          }
      },
      init:function(){
          this.getContentImage("6146").then(data=>{
            if(data.errorCode == 0){
                this.imageList = data.result;
                for(var i = 0;i< data.result.length;i++){
                    if(this.imageData.length < 5){
                        this.imageData.push(data.result[i]);
                    }
                }
                this.scorllImage();
            }
        });

        this.getContentNotice().then(data=>{
            if(data.errorCode == 0){
                for(var i in data.result){
                    if(data.result[i].channelId == 6178){
                        //通知公告
                        if(this.noticeData.notice.length < 5){
                            this.noticeData.notice.push(data.result[i]);
                        }
                    }else if(data.result[i].channelId == 6254){
                        //党务指南
                        if(this.noticeData.dwzn.length < 5){
                            this.noticeData.dwzn.push(data.result[i]);
                        }
                    }else if(data.result[i].channelId == 6177){
                        //人事任免
                        if(this.noticeData.rsrm.length < 5){
                            this.noticeData.rsrm.push(data.result[i]);
                        }
                    }
                }
            }
        });

        var ids = [];
        for(var i in this.areaData){
            ids.push(this.areaData[i].code);
        }
        /**
        this.getContentArea(ids.join("-")).then(data=>{
            if(data.errorCode == 0 && data.result){
                for(var i in data.result){
                    for(var j in this.areaData){
                        if(this.areaData[j].code == data.result[i].channelId){
                            if(this.areaData[j].list.length < 4){
                                this.areaData[j].list.push(data.result[i]);
                            }
                            break;
                        }
                    }
                }
                for(var j in this.areaData){
                    if(this.areaData[j].code == 6230){
                        this.cityData.fjq = this.areaData[j].list;
                    }else if(this.areaData[j].code == 6231){
                        this.cityData.kfq = this.areaData[j].list;
                    }
                }
            }
        });
        **/
        for(var k in this.cultureData){
            this.initModuleData(k);
        }

        ids = [];
        for(var i in this.bannerData){
            ids.push(this.bannerData[i].code);
        }
        this.getContentArea(ids.join("-")).then(data=>{
            if(data.errorCode == 0 && data.result){
                for(var i in data.result){
                    if(data.result[i].channelId == 6176 || data.result[i].channelId == 6175 || data.result[i].channelId == 6145){
                        if(!this.sszzData.head.title){
                            this.sszzData.head = data.result[i];
                        }else{
                            if(this.sszzData.body.length < 6){
                                this.sszzData.body.push(data.result[i]);
                            }
                        }
                    }else if(data.result[i].channelId == 6146){
                        if(!this.qyywData.head.title){
                            this.qyywData.head = data.result[i];
                        }else{
                            if(this.qyywData.body.length < 6){
                                this.qyywData.body.push(data.result[i]);
                            }
                        }
                    }
                    for(var j in this.bannerData){
                        if(this.bannerData[j].code == data.result[i].channelId){
                            if(this.bannerData[j].list.length < 4){
                                this.bannerData[j].list.push(data.result[i]);
                            }
                            break;
                        }
                    }
                }
            }
        });

        //理论文献7101  红色记忆7102  党建经纬7107   精品党课7104 乡村振兴7103  
        //移除 法制教育7105和卫生健康7106  
        /** 
        this.getContentArea("7101-7102-7107-7104-7103-7108").then(data=>{
            if(data.errorCode == 0 && data.result){
                var tempData = {};
                var tempIds = [];
                for(var i in data.result){
                    if(tempIds.indexOf(data.result[i].channelId) == -1){
                        tempIds.push(data.result[i].channelId);
                    }
                    if(!tempData[data.result[i].channelId]){
                        tempData[data.result[i].channelId] = {
                            "channelId":data.result[i].channelId,
                            "channelName":data.result[i].channelName,
                            "data":[]
                        };
                        if(i == 0){
                            tempData[data.result[i].channelId]['check'] = true;
                        }else{
                            tempData[data.result[i].channelId]['check'] = false;
                        }
                    }
                    if(tempData[data.result[i].channelId].data.length < 4){
                        tempData[data.result[i].channelId].data.push(data.result[i]);
                    }
                }
                this.kczxData = [];
                for(var i in tempIds){
                    this.kczxData.push(tempData[tempIds[i]]);
                }
            }
        });
        */

        //党建栏目（潜山栏目、安全栏目、安徽栏目、中央栏目）
        this.getContentArea("7201-7202-7203-7204").then(data=>{
            if(data.errorCode == 0 && data.result){
                var tempData = {};
                var tempIds = [];
                for(var i in data.result){
                    if(tempIds.indexOf(data.result[i].channelId) == -1){
                        tempIds.push(data.result[i].channelId);
                    }
                    if(!tempData[data.result[i].channelId]){
                        tempData[data.result[i].channelId] = {
                            "channelId":data.result[i].channelId,
                            "channelName":data.result[i].channelName,
                            "data":[]
                        };
                        if(i == 0){
                            tempData[data.result[i].channelId]['check'] = true;
                        }else{
                            tempData[data.result[i].channelId]['check'] = false;
                        }
                    }
                    if(tempData[data.result[i].channelId].data.length < 4){
                        tempData[data.result[i].channelId].data.push(data.result[i]);
                    }
                }
                this.djlmData = [];
                for(var i in tempIds){
                    this.djlmData.push(tempData[tempIds[i]]);
                }
            }
        });

        //先锋影视
        /**
        this.getContentArea("7300").then(data=>{
            if(data.errorCode == 0 && data.result){
                for(var i in data.result){
                    if(this.xfysData.length < 6){
                        this.xfysData.push(data.result[i]);
                    }
                }
            }
        });
        */

      },
      onModuleData:function(index,size,name){
          OMO2(index,size,name);
      },
      initModuleData:function(index){
        this.getModuleContent(this.cultureData[index].code).then(data=>{
            if(data.errorCode == 0 && data.result && data.result.length > 0){
                this.cultureData[index].list = [];
                for(var i in data.result){
                    //仅显示8条记录
                    if(data.result[i] && data.result[i].length > 8){
                        data.result[i].splice(8);
                    }
                    if(data.result[i] && data.result[i].length > 0){
                        this.cultureData[index].list.push({
                            "code":data.result[i][0].channelId,
                            "name":data.result[i][0].channelName,
                            "data":data.result[i]
                        });
                    }
                }
                //对list进行排序
                // this.cultureData[index].list.sort((a,b)=>b.code-a.code);
            }
        });
      },
      getContentNotice:function(){
          return request({  
                url: '/index/getContentNotice',
                method: 'get',
                params: { idStr:"6178-6177-6254" }
            })
      },
      getContentArea:function(idStr){
        return request({
            url: '/index/getAreaList',
            method: 'get',
            params: { idStr:idStr }
        })
      },
      getModuleContent:function(code){
        return request({
          url: '/index/getModuleContent',
          method: 'get',
          params: { 
            "channelId":code
          }
        })
      },
      getContentImage:function(idStr){
        return request({
          url: '/index/getContentImage',
          method: 'get',
          params: { 
            "idStr":idStr
          }
        })
      },
      showImage:function(url){
          if(url && (url.indexOf("http:") > -1 || url.indexOf("https:") > -1 || url.indexOf("sti") > -1)){
              return url;
          }
          return "/static-oss/qsxfoldfile/picture/" + url;
      },
      scorllImage:function(){
          var speed = 30
            // demo2.innerHTML = demo1.innerHTML
            var demo = document.getElementById("demo");
            var demo2 = document.getElementById("demo2");
            function Marquee() {
                if (demo.scrollLeft<=0) {
                    demo.scrollLeft+=demo2.offsetWidth
                }
                else {
                    demo.scrollLeft--
                }
            }
        if(demo){
            var MyMar = setInterval(Marquee, speed)
            demo.onmouseover = function () { clearInterval(MyMar) }
            demo.onmouseout = function () { MyMar = setInterval(Marquee, speed) }
        }
      },
      changeStatus:function(item,list){
          for(var i in list){
              if(list[i].channelId != item.channelId){
                list[i].check = false;
              }
          }
          item.check = true;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.searchform{background:url(/static/images/search_l.jpg); border:0; height:25px; width:153px; padding:0 22px 0 5px;}


.wd960{width:960px; position:relative; margin:0 auto;font:14px "微软雅黑","宋体"; }
.clear{ clear:both;}
.wd960 a{ font-family:"微软雅黑","宋体"; font-size:14px;text-decoration: none; font-style:normal; letter-spacing:normal; color:#003c78;}
.wd960 A:hover {COLOR: #4e667b; TEXT-DECORATION: underline} 
.wd960 A:active {TEXT-DECORATION: none}
 
.lmtop2{width:100%;height:80px; background:#f3f3f3;position: relative;}
.lmtop2 p{line-height:50px;}
.lmtop2 h1{font-size:22px; color:#082e6c; margin-top:5px;}
.lmtop2 h1 span{font-size:14px; color:#666666; font-weight:normal;}
 
.lmtop3{width:100%; height:auto; background:#fff; float:left ;border-bottom:0px solid #07357f;position: relative; padding:5px 0px;}
.lmtop3 ul { margin:0px; padding:0px;}
.lmtop3 ul li{width:90px;height:25px;line-height:25px; float:left; padding-right: 10px; text-align:center; }
.lmtop3 ul li a{font-weight: bold;color: #333;font-size: 16px;}
.lmtop3 ul li a:hover{ color:#c00;TEXT-DECORATION: none}
.lmtop3 ul li a span{font-size:12px; font-weight:normal; color:#666666;}
 
.up,.down{overflow:hidden; display:block;}
#down{display:none;}
.updown{display:block;width:70px;height:41px;position:absolute;top:160px;right:250px;z-index:9999;}
.updown a{ font-family:"微软雅黑","宋体"; font-size:14px;text-decoration: none; font-style:normal; letter-spacing:normal; color:#003c78;}
.updown A:hover {COLOR: #4e667b; TEXT-DECORATION: underline} 
.updown A:active {TEXT-DECORATION: none}
.style1 {
	text-align: left;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeIndex.vue